// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { chain, RemoveNotAvailableAttributeValues } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";


export const XngRemoveNotAvailableAttributeValues: typeof RemoveNotAvailableAttributeValues = props => {
    const productsDataView = getProductsDataView(props.getState(), props.apiParameter);
    
    // XNG-Changes
    // Return if !productsDataView.value?.length
    // OOTB sets productsDataView.value as an empty array [] which doesn't return
    if (!productsDataView.value || !productsDataView.value?.length) {
        return;
    }

    RemoveNotAvailableAttributeValues(props);
};

replaceInChain(chain, RemoveNotAvailableAttributeValues, XngRemoveNotAvailableAttributeValues);